import React, { useState, useEffect } from 'react';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import AppConfirmDialog from '../../../AppConfirmDialog';
import { useGetTargetUsersQuery } from '@libs/react-query/src/queries/channelUserMigration/useGetTargetUsersQuery';
import { useChannelUserMigrationMutation } from '@libs/react-query/src/queries/channelUserMigration/useChannelUserMigrationMutation';

const DataMigrationBanner = () => {
  const domain = process.env.NX_APPLICATION;
  const { data: targetUsersData } = useGetTargetUsersQuery(domain || '');
  const migrationMutation = useChannelUserMigrationMutation();

  const [isMigrationDialogOpen, setIsMigrationDialogOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number | ''>('');

  const handleOpenMigrationDialog = () => {
    setIsMigrationDialogOpen(true);
    setSelectedUserId('');
  };

  const handleCloseMigrationDialog = () => {
    setIsMigrationDialogOpen(false);
    setSelectedUserId('');
  };

  const handleConfirmMigration = () => {
    if (selectedUserId) {
      migrationMutation.mutate(selectedUserId as number, {
        onSuccess: () => {
          setIsMigrationDialogOpen(false);
          setSelectedUserId('');
        },
      });
    }
  };

  return (
    <>
      <Box
        component="div"
        onClick={handleOpenMigrationDialog}
        sx={{
          width: '100%',
          height: '48px',
          minHeight: '48px',
          background: 'linear-gradient(90deg, rgba(229, 0, 255, 1) 0%, rgba(0, 172, 255, 1) 100%)',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '14px',
          fontWeight: 500,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          boxSizing: 'border-box',
          cursor: 'pointer',
          '&:hover': {
            opacity: 0.9,
          },
        }}
      >
        {`기존 데이터 이관 신청 하시려면 여기를 클릭하세요. >`}
      </Box>
      <AppConfirmDialog
        open={isMigrationDialogOpen}
        onDeny={handleCloseMigrationDialog}
        onConfirm={handleConfirmMigration}
        dialogTitle="기존 데이터 이관 신청"
        confirmTitle="네, 이관해 주세요."
        denyTitle="아니요."
        confirmDisabled={!selectedUserId}
        title={
          <Box>
            <Typography sx={{ mb: 10, fontSize: 15, color: '#191919' }}>
              기존에 등록한 디자인, POD 상품 데이터를 이관하여 드려요.
              <br />
              이관 후에는 복원되지 않으니 주의해 주세요.
              <br />
              데이터 이관은 최대 24시간이 소요될 수 있습니다.
            </Typography>
            <FormControl fullWidth>
              <Select
                labelId="migration-user-select-label"
                id="migration-user-select"
                value={selectedUserId}
                onChange={(e) => setSelectedUserId(e.target.value as number)}
                displayEmpty
                renderValue={(value) => {
                  if (!value) {
                    return '이관할 관리자를 선택하세요.';
                  }
                  const selectedUser = targetUsersData?.find((user: any) => user.id === value);
                  return selectedUser ? `${selectedUser.name} ${selectedUser.email}` : '';
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300,
                    },
                  },
                }}
              >
                {targetUsersData?.map((user: any) => (
                  <MenuItem key={user.id} value={user.id}>
                    {user.name} {user.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        }
      />
    </>
  );
};

export default DataMigrationBanner;
